import { del, get, post, put } from '../request';
import { toPage, type Page, type PageQuery } from './types';

/** 黑名单（/blacklists）：命中号码呼入直接拦截 */
export interface BlacklistItem {
  id: number;
  number: string;
  reason?: string;
  /** 添加人 user_id + 姓名 */
  created_by?: number;
  created_by_name?: string;
  /** 过期时间（空=长期；到点自动解除拦截） */
  expires_at?: string | null;
  /** 最近拦截时间 */
  last_blocked_at?: string | null;
  /** 拦截总数 */
  block_count?: number;
  enabled?: boolean;
  created_at?: string;
  [k: string]: any;
}

export interface BlacklistQuery extends PageQuery {
  /** 号码模糊匹配 */
  number?: string;
}

/** GET /blacklists */
export async function listBlacklists(q?: BlacklistQuery): Promise<Page<BlacklistItem>> {
  return toPage<BlacklistItem>(await get('/blacklists', q || {}));
}

export function createBlacklist(v: { number: string; reason?: string; enabled?: boolean; expires_at?: string | null }) {
  return post('/blacklists', v);
}

export function updateBlacklist(id: number, v: Partial<BlacklistItem>) {
  return put(`/blacklists/${id}`, v);
}

/** 启停开关：只提交 { enabled }（白名单部分更新） */
export function setBlacklistEnabled(id: number, enabled: boolean) {
  return put(`/blacklists/${id}`, { enabled });
}

export function deleteBlacklist(id: number) {
  return del(`/blacklists/${id}`);
}

// ---------- 批量导入 ----------

export interface BlacklistImportError {
  /** xlsx/csv 中的真实行号（含表头） */
  row: number;
  number: string;
  reason: string;
}

export interface BlacklistImportResult {
  ok_rows: number;
  dup_rows: number;
  invalid_rows: number;
  errors: BlacklistImportError[];
}

/** GET /blacklists/import-template：批量导入模板（xlsx 下载，需带 token） */
export function getBlacklistImportTemplateUrl() {
  return '/api/v1/blacklists/import-template';
}

/** POST /blacklists/import：xlsx/csv 上传导入（multipart file；策略 A 部分成功，返回失败明细） */
export async function importBlacklists(file: File): Promise<BlacklistImportResult> {
  const fd = new FormData();
  fd.append('file', file);
  return post('/blacklists/import', fd, { timeout: 60000 });
}

// ---------- 拦截历史 ----------

export interface BlacklistHit {
  id: number;
  blacklist_id: number;
  number: string;
  caller: string;
  cdr_id?: number | null;
  blocked_at?: string;
  [k: string]: any;
}

/** GET /blacklists/hits?blacklist_id=&page=&pageSize= */
export async function listBlacklistHits(q: { blacklist_id?: number } & PageQuery): Promise<Page<BlacklistHit>> {
  return toPage<BlacklistHit>(await get('/blacklists/hits', q || {}));
}
